module.exports = __webpack_public_path__ + "media/application/images/ui/icon-close-e3634c5875dd0b6d03d9ffd045089a5c.png";